import React from 'react';
import { formatConfigForPDF } from '../utils/pdfExport';

const ConfigurationSummary = ({ config, className = '' }) => {
  const configItems = formatConfigForPDF(config);
  
  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      <h3 className="text-lg font-semibold mb-4 text-gray-800">
        Riepilogo Configurazione
      </h3>
      
      <div className="space-y-3">
        {configItems.map((item, index) => (
          <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0">
            <span className="text-sm font-medium text-gray-600">
              {item.label}
            </span>
            <span className="text-sm text-gray-800 font-medium">
              {item.value}
            </span>
          </div>
        ))}
      </div>
      
      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="text-xs text-gray-500 text-center">
          TAAPP - Pergole Innovative
        </div>
      </div>
    </div>
  );
};

export default ConfigurationSummary;